import React from 'react';

interface TokenStat {
    value: string;
    label: string;
}

interface TokenInfoProps {
    stats: TokenStat[];
    className?: string;
}

export const TokenInfo: React.FC<TokenInfoProps> = ({
    stats,
    className = '',
}) => {
    return (
        <div className={`ecosystem-token ${className}`}>
            {stats.map((stat, index) => (
                <div key={index} className="ecosystem-token-stat">
                    <div className="ecosystem-token-value">{stat.value}</div>
                    <div className="ecosystem-token-label">{stat.label}</div>
                </div>
            ))}
        </div>
    );
};

export default TokenInfo;
